import useStore from '@/store/useStore'
import { ComponentStatusKeys } from '@/types/storeTypes/commonStoreTypes'

export const useComponentLoadingState = (key: ComponentStatusKeys) => {
  const isLoading = useStore((state) => state.common.isLoading)
  const hasError = useStore((state) => state.common.hasError)

  return {
    isLoading: isLoading[key],
    hasError: hasError[key],
  }
}
